import React, { useState } from 'react';

function Footer() {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    console.log('Subscribing:', email);
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3 className="footer-heading">Other Links</h3>
          <ul className="footer-links">
            <li><a href="#space">Space</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#community">Community</a></li>
            <li><a href="#news">News</a></li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-heading">Connect with us</h3>
          <ul className="footer-links">
            <li><a href="https://facebook.com/bunihub" aria-label="Follow us on Facebook">Facebook</a></li>
            <li><a href="https://twitter.com/bunihub" aria-label="Follow us on Twitter">Twitter</a></li>
            <li><a href="https://instagram.com/bunihub" aria-label="Follow us on Instagram">Instagram</a></li>
            <li><a href="https://youtube.com/bunihub" aria-label="Subscribe to our YouTube channel">Youtube</a></li>
            <li><a href="https://linkedin.com/company/bunihub" aria-label="Connect with us on LinkedIn">LinkedIn</a></li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-heading">Get Notified</h3>
          <p className="footer-description">
            Keep Up With Our Works. Subscribe To Our Newsletter and Receive Updates.
          </p>
          <form className="footer-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="footer-input"
              required
            />
            <button type="submit" className="footer-button">
              SUBSCRIBE
            </button>
          </form>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p className="footer-copyright">© {year} Copyright BuniHub</p>
      </div>
    </footer>
  );
}

export default Footer;


